import React from "react";
import { Box } from "../Box";
import * as Radio from "../Radio_v2";
import { ResourceCounter } from "./ResourceCounter";
import { VPCNote } from "./VPCNote";
import { VPC } from "./types";

type Props = {
  /**
   * The name of the radio group. Used as the `name` attribute on the radio inputs.
   */
  name: string;
  /**
   * The value of the currently selected radio button.
   */
  selected: string | null;

  onSelect(id: string): void;

  /**
   * The VPC options that appear in the radio group.
   */
  options: VPC[];

  /**
   * Whether the entire radio group is disabled.
   * @default false
   */
  disabled?: boolean;

  /**
   * Testing utility function. Called with each radio button's `value` prop.
   * @default undefined
   */
  "data-testid"?: (value: string) => string;
};

export const VPCRadioGroup: React.FC<Props> = (props) => {
  const { name, selected, onSelect, options, disabled = false } = props;
  const testId = props["data-testid"];

  const label = {
    text: "VPC Network",
    tooltip: "This resource can communicate over Private IP address only with other resources in the same VPC network.",
  };

  return (
    <>
      <Radio.Group name={name} label={label} selected={selected} onSelect={onSelect}>
        {options.map((vpc) => {
          const rightSide =
            vpc.resources.length > 0 ? <ResourceCounter resources={vpc.resources} disabled={disabled} area="vpc" /> : undefined;
          return (
            <Radio.Button key={vpc.value} value={vpc.value} title={vpc.value} rightSide={rightSide} data-testid={testId?.(vpc.value)} />
          );
        })}
      </Radio.Group>
      <Box mt={4}>
        <VPCNote />
      </Box>
    </>
  );
};

VPCRadioGroup.displayName = "VPCRadioGroup";
